<template>
  <div>
    <report-panel :anchor="''">
      <div slot="title">Shareholding</div>
      <div slot="body">
        <table class="table table-striped" id="shareholders-table">
          <tbody>
            <tr>
              <th scope="row">Shareholder:</th>
              <th scope="row" class="text-right">Shares:</th>
              <th scope="row">Type:</th>
            </tr>
            <tr v-for="shareholder in report.companyoverview.shareholders" :key="shareholder.id">
              <td>{{ shareholder.name }}</td>
              <td class="text-right"
                  v-html="numberOfSharesInfo(shareholder)" />
              <td v-html="shareClassInfo(shareholder)" />
            </tr>
          </tbody>
        </table>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  methods: {
    numberOfSharesInfo(shareholder) {
      let result = '';
      if (shareholder.share_classes.length > 0) {
        for (let i = 0; i < shareholder.share_classes.length; i += 1) {
          result += this.delimitNumbers(shareholder.share_classes[i].number_of_shares) + '<br />';
        }
        result = result.substr(0, result.length - 6);
      } else {
        result = this.delimitNumbers(shareholder.number_of_shares);
      }
      return result;
    },
    shareClassInfo(shareholder) {
      let result = '';
      if (shareholder.share_classes.length > 0) {
        for (let i = 0; i < shareholder.share_classes.length; i += 1) {
          result += shareholder.share_classes[i].share_class + '<br />';
        }
        result = result.substr(0, result.length - 6);
      } else {
        result = shareholder.share_class;
      }
      return result;
    },
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
